/** React pages call {@link bindSharedToast} once to wire local toast state into {@link sharedShowToast}. */
let toastHandlers = null;
let toastHideTimerId = null;

/**
 * @param {{ setMessage: (s: string) => void; setType: (s: string) => void; setVisible: (v: boolean) => void }} handlers
 */
export function bindSharedToast(handlers) {
    toastHandlers = handlers;
}

export function unbindSharedToast() {
    if (toastHideTimerId != null) {
        window.clearTimeout(toastHideTimerId);
        toastHideTimerId = null;
    }
    toastHandlers = null;
}

/** Shows a toast if the current route has registered handlers via bindSharedToast. */
export function sharedShowToast(message, type = "warning", durationMs = 3000, callback = null) {
    if (!toastHandlers) {
        return;
    }
    toastHandlers.setMessage(message);
    toastHandlers.setType(type);
    toastHandlers.setVisible(true);
    if (toastHideTimerId != null) {
        window.clearTimeout(toastHideTimerId);
    }
    toastHideTimerId = window.setTimeout(() => {
        toastHandlers?.setVisible(false);
        toastHideTimerId = null;
        if (callback !== null) {
            callback();
        }
    }, durationMs);
}